import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('audio-player-loader', {
  template: require('./template.html'),
  name: 'audio-player-loader',
  computed: {
    ...mapGetters(['activeDroplet']),
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-player/components/_preview/loader/index.js